module.exports = __webpack_public_path__ + "static/media/DropDownCaret.91e0f0fc.svg";